import { CheckCircle, AlertCircle } from "lucide-react";

const bringItems = [
  { text: "T-shirt", icon: "👕" },
  { text: "Tracksuit bottoms or leggings", icon: "👖" },
  { text: "Clean trainers", icon: "👟" },
  { text: "Water bottle", icon: "💧" },
  { text: "Nut-free packed lunch", icon: "🥪" },
];

const weProvide = [
  "Full fencing kit",
  "Masks & protective gear",
  "Weapons (foils)",
  "Expert coaching",
];

export default function WhatToWearSection() {
  return (
    <section
      id="what-to-wear"
      className="py-20 bg-[#F4F4F4]"
      data-testid="what-to-wear-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#0A1A2F]/10 text-[#0A1A2F] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
              <CheckCircle size={16} />
              Simple Checklist
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-6 font-['Montserrat']">
              What to <span className="text-[#D4A857]">Wear & Bring</span>
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 font-['Lato']">
              Keep it simple! Here's everything your child needs to bring. 
              We take care of all the fencing equipment.
            </p>

            {/* Bring List */}
            <div className="bg-white rounded-lg p-6 shadow-sm mb-6 border border-[#F4F4F4]">
              <p className="font-bold text-[#0A1A2F] mb-4 flex items-center gap-2 font-['Montserrat']">
                <span className="text-2xl">🎒</span> Please Bring:
              </p>
              <div className="space-y-3">
                {bringItems.map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <span className="text-2xl">{item.icon}</span>
                    <span className="text-[#0A1A2F] font-medium font-['Lato']">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* We Provide */}
            <div className="bg-[#D4A857]/10 rounded-lg p-6 border border-[#D4A857]/20">
              <p className="font-bold text-[#D4A857] mb-4 flex items-center gap-2 font-['Montserrat']">
                <CheckCircle size={20} /> We Provide:
              </p>
              <div className="grid grid-cols-2 gap-3">
                {weProvide.map((item, i) => (
                  <div key={i} className="flex items-center gap-2 text-[#0A1A2F]">
                    <span className="text-[#D4A857]">✓</span>
                    <span className="font-medium text-sm font-['Lato']">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Visual with Masky - Small */}
          <div className="relative">
            <div className="bg-[#0A1A2F] rounded-lg p-8 text-white text-center">
              <img
                src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
                alt="Masky with checklist"
                className="w-44 mx-auto mb-6 masky-glow"
              />
              
              <div className="bg-white/10 rounded-lg p-5 backdrop-blur-sm border border-white/20">
                <p className="font-bold text-[#D4A857] mb-2 font-['Montserrat'] uppercase text-sm">Masky's Reminder:</p>
                <p className="text-white/90 font-['Lato']">
                  "No shorts please — long trousers keep you safe while we fence! 
                  And don't forget your lunch — all that fencing will make you hungry!"
                </p>
              </div>
            </div>
            
            {/* Important Note */}
            <div className="absolute -bottom-4 left-4 right-4 bg-[#D4A857] text-[#0A1A2F] p-4 rounded-lg shadow-lg flex items-start gap-3">
              <AlertCircle className="flex-shrink-0 mt-0.5" size={20} />
              <p className="text-sm font-medium font-['Lato']">
                <span className="font-bold">Lunch must be nut-free</span> — we have a strict nut-free policy for everyone's safety.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
